// _$lsImpl_ will get set by localStoragePolyFill which gets loaded
// at the begginning of the template.html file
interface WithStorageHelper {
  _$lsImpl_: Storage;
}

const win: WithStorageHelper = <any>window;

export const localStorageHelper = win._$lsImpl_;
